<script>
const sidebarMenu = [
  // { path: '/', icon: 'fa fa-th', title: 'Home' },

  //HOMEPAGE
  { path: '/home', icon: 'fas fa-home', title: 'Home' },

  //WORK ORDER FORM
  { path: '/work-order-form', icon: 'fas fa-clipboard', title: 'Work Order' },

  //CSO
  { path: '/cso', icon: 'fas fa-table', title: 'CSO',
    children: [
      { path: '/cso/exit-permit', title: 'Gatepass' },
      { path: '/cso/customer-quotation', title: 'Quotation' },
      { path: '/cso/insurance-policy', title: 'Insurance Policy' },
      { path: '/cso/master-data', title: 'Master Data',
        children: [
          { path: '/cso/master-data/color', title: 'Warna Mobil' },
          { path: '/cso/master-data/brand-&-type', title: 'Merk Dan Tipe Mobil' },
          { path: '/cso/master-data/customer', title: 'Pelanggan' },
          { path: '/cso/master-data/customer-car', title: 'Mobil Pelanggan' },
          { path: '/cso/master-data/laborer', title: 'Pekerja' },
          { path: '/cso/master-data/supplier', title: 'Supplier' },
        ]
      },
    ]
  },

  //ESTIMATOR
  { path: '/estimator', icon: 'fas fa-balance-scale', title: 'Estimator',
    children: [
      { path: '/estimator/master-insurance', title: 'Asuransi' },
      { path: '/estimator/estimator-application', title: 'Estimator' },
      { path: '/estimator/complain-work-order', title: 'Complain' },
      { path: '/estimator/sparepart-estimations', title: 'Parts Quotation' },
    ]
  },

  //Inventory
  { path: '/inventory', icon: 'fas fa-boxes', title: 'Gudang',
    children: [
      { path: '/inventory/master-sparepart', title: 'Master Suku Cadang' },
      { path: '/inventory/inventory-usage', title: 'Pengunaan Suku Cadang' },
      { path: '/inventory/sparepart-purchasing', title: 'Pembelian Suku Cadang' },
      { path: '/inventory/salvage-parts', title: 'Salvage Parts' },
    ]
  },

  //Report
  { path: '/report', icon: 'fas fa-poll', title: 'Laporan',
    children: [
      { path: '/report/insurance-report', title: 'Laporan Asuransi' },
      { path: '/report/petty-cash', title: 'Kas Kecil' },
      { path: '/report/own-risk', title: 'Own Risk' },
      { path: '/report/inventory-usage', title: 'Pengunaan Barang' },
      { path: '/report/po-sparepart', title: 'PO Suku Cadang' },
      { path: '/report/revenue', title: 'Penghasilan' },
    ]
  },

  //Financing Module
  { path: '/finance', icon: 'fas fa-dollar-sign', title: 'Keuangan',
    children: [
      { path: '/finance/petty-cash', title: 'Kas Kecil' },
      { path: '/finance/jasa-borongan', title: 'Jasa Borongan' },
      { path: '/finance/work-order-payment', title: 'Pembayaran Work Order' },
    ]
  },

  //Human Resource
  { path: '/human-resource', icon: 'fas fa-user-friends', title: 'Human Resource',
    children: [
      { path: '/human-resource/absence', title: 'Absensi' },
      { path: '/human-resource/kpi', title: 'KPI' },
    ]
  },

  //Human Resource
  { path: '/setting', icon: 'fas fa-wrench', title: 'Pengaturan',
    children: [
      { path: '/setting/user-management', title: 'User' },
      { path: '/setting/role-management', title: 'Role' },
      { path: '/setting/price-list', title: 'Kategori Pricelist' },
      { path: '/setting/checklist-work-order-items', title: 'Daftar Periksa Barang Work Order' },
      { path: '/setting/company-detail', title: 'Informasi Perusahaan' },
    ]
  }
]

export default sidebarMenu;
</script>
